import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import { Paper, Typography, LinearProgress } from '@material-ui/core';
import { ShowShareTable, QueryFilter, QUERY_FILTER_MARKET, IShareTableData } from 'src/component/shared';
import { MarketShareRankingPublishersModal } from './MarketShareRankingPublishersModal';
// tslint:disable-next-line:no-empty-interface
export interface IMarketShareRankingPublishersProps {
    type: string;
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareRankingPublishersState {
    isUpdate: boolean,
    customFilter: {
        isChart: boolean
    },
}

const MARKET_RANKING_PUBLISHERS = gql`
query marketShareRankingPublishers($customFilter:  MarketShareCustomFilter) {
    marketShareRankingPublishers(marketShareCustomFilter: $customFilter) {
        name,
        value
    }
}
`;

const dataFilled = (data: any) => {
    return data && data.marketShareRankingPublishers && !!data.marketShareRankingPublishers.length
}

export class MarketShareRankingPublishers extends React.Component<IMarketShareRankingPublishersProps, IMarketShareRankingPublishersState> {
    constructor(props: IMarketShareRankingPublishersProps) {
        super(props);
        this.state = {
            customFilter: {
                isChart: true,
            },
            isUpdate: false,
        }

    }

    public render() {
        const jsonFilter = {
          "customFilter": {
            "isChart": this.state.customFilter.isChart,
            "type": this.props.type,
          }
        };

        return (
            <Query query={QUERY_FILTER_MARKET} notifyOnNetworkStatusChange={true}  >
                {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {
                    return (
                        <Query query={MARKET_RANKING_PUBLISHERS} variables={QueryFilter.getFilterMarket(clientC, jsonFilter, [], false)}>
                            {({ loading, error, data, client}) => {
                                return this.dataToRend(data, loading);
                            }}
                        </Query>
                    );

                }}
            </Query>
        )
    }

    /**
     * Método utilizado para renderizar as informações do card
     * Foi destacado do restante do código para que seja reutilizado nas requisições de cache e do graphql
     */
    private dataToRend (data:any, loading:any) {
        return  (
            <Paper className="publisher-sale-block panel-block">
                <Typography variant="headline" className="panel-title" component="title">
                    Ranking Editoras - 30 Dias
                </Typography>
                {
                    loading
                    ?
                    <LinearProgress />
                    :
                    (
                        dataFilled(data)
                        ?
                        (
                            <div>
                                <div style={{height: 334, overflowX: 'auto', overflowY: 'hidden'}}>
                                    <ShowShareTable data={data.marketShareRankingPublishers.filter(
                                        (element:IShareTableData, index: number) => index<=10 )}/>
                                </div>
                                <MarketShareRankingPublishersModal type={this.props.type} />
                            </div>
                        )
                        :
                        (<Typography variant="body2" className="comparative" component="p">
                            Não há informações de vendas
                        </Typography>)
                    )
                }
            </Paper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/component/market/general/publishers/shared/ranking/MarketShareRankingPublishers.tsx